// extracted by mini-css-extract-plugin
export default {"wrapperTabs":"Tabs_wrapperTabs__qWvnA","wrapperTab":"Tabs_wrapperTab__x9lXp","activeTab":"Tabs_activeTab__xq6hJ"};